import React from 'react';
import { Palmtree } from 'lucide-react';

const ITEMS = ['16 Acre Tropical Ecosystem', '70% Open Spaces', '60+ World-Class Amenities', '30 Varieties of Palm Trees', 'Homes with Balconies', '5 Mins from Shilphata Jn.'];

const Marquee = () => (
  <div className="overflow-hidden bg-palm py-4" aria-hidden="true" data-testid="usp-marquee">
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0">
          {ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="mx-8 flex items-center gap-3 text-ivory/90 text-xs sm:text-sm tracking-[0.25em] uppercase font-medium whitespace-nowrap">
              <Palmtree className="h-4 w-4 text-gold" strokeWidth={1.5} />
              {item}
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
